import {IPolicyFormData} from "../types/policies.types";
import {Policy} from "../../../domains/models/policy";
import server from "../../../server";
import {RcFile} from "antd/lib/upload";
import {MetaPayload} from "../../../domains/models/document";

export function modelMapper(data: IPolicyFormData): Policy {
    return {
        title: data.title,
        documentId: data.documentId,
        description: data.description,
        applicableFrom: new Date(data.applicableFrom.format("YYYY-MM-DD")),
        notifyEmployees: data.notifyEmployees,
    }
}

export async function uploadPolicyDocument(file: RcFile, meta?: MetaPayload[]) {
    const res = await server.document.upload(file, 'POLICY', undefined, undefined, meta);
    return res;
}

export async function createPolicy(payload: any) {
    const response = await server.policy.create(payload);
    return response;
}

export async function fetchPolicy(policyId: string) {
    const res = await server.policy.get(policyId);
    return res;
}

export async function deletePolicyDocument(docId: string) {
    await server.document.delete(docId);
}

export async function deletePolicy(policyId: string) {
    await server.policy.delete(policyId);
}

export async function getMetaFields() {
    const metaRes = await server.document.fetchMetaData('POLICY');
    return metaRes;
}

